import { useGlobalQuery } from '@/state/query-client/hooks';
import { getContactCantons } from '../services/contact-info-lookups.service';

/** Cantons of the active organization. */
export const useGetContactCantons = () => {
  return useGlobalQuery({
    queryKey: ['hr-contact-cantons'],
    queryFn: () => getContactCantons(),
    staleTime: 30 * 60 * 1000,
  });
};
